import React, { useState } from "react";
import { Button, makeStyles, Text } from "@fluentui/react-components";
import { themeTokens } from "../../utils/Theming";
import BottomFixedButton from "../../blocks/BottomFixedButton";
import FormField from "./FormField";

const useStyles = makeStyles({
  form: {
    height: "calc(100% - 92px)",
    overflowY: "auto",
  },
  field: {
    marginBottom: themeTokens.spacingVerticalM,
    width: "100%",
  },
  button: {
    display: "block",
    width: "100%",
  },
  title: {
    marginBottom: themeTokens.spacingVerticalM,
    color: themeTokens.colorNeutralForeground1,
  },
});

const Form = ({ fields, onSubmit, title = "", buttonText = "Save", buttonBottom = true }) => {
  const styles = useStyles();
  const [formData, setFormData] = useState(
    fields.reduce((acc, field) => {
      acc[field.name] = field.initialValue !== undefined ? field.initialValue : "";
      return acc;
    }, {})
  );
  const [errors, setErrors] = useState({});

  const handleInputChange = (name, value) => {
    setFormData({ ...formData, [name]: value });
  };

  const validate = () => {
    let valid = true;
    const newErrors = {};

    fields.forEach((field) => {
      if (field.validation) {
        const error = field.validation(formData[field.name]);
        newErrors[field.name] = error;
        if (error) {
          valid = false;
        }
      }
    });

    setErrors(newErrors);
    return valid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      onSubmit(formData);
    }
  };

  return (
    <form onSubmit={handleSubmit} className={styles.form}>
      {title && (
        <Text className={styles.title} size={400} weight="bold" block>
          {title}
        </Text>
      )}

      {fields.map((field) => (
        <div key={field.name} className={styles.field}>
          <FormField
            type={field.type}
            name={field.name}
            label={field.label}
            options={field.options}
            value={formData[field.name] || ""}
            error={errors[field.name]}
            readOnly={field.readOnly}
            onChange={handleInputChange}
          />
        </div>
      ))}

      {buttonBottom ? (
        <BottomFixedButton appearance="primary" type="submit" buttonText={buttonText} />
      ) : (
        <Button className={styles.button} appearance="primary" type="submit">
          {buttonText}
        </Button>
      )}
    </form>
  );
};

export default Form;
